import axios, { buildRequestCancelation } from '../../../configs/axios';

import { makeAppAssetList, fetchAppQuickview, fetchAppQuickviewDetails } from './app-qv';
import { makePubAssetList, fetchPubQuickview, pushPublisherToSalesforce } from './pub-qv';
import { makeCompanyAssetList, fetchCompanyQuickview } from './company-qv';

export { makeAppAssetList, makePubAssetList, makeCompanyAssetList };

// Api requests
export default {
  isCancel: axios.isCancel,
  buildRequestCancelation,
  fetchAppQuickview,
  fetchAppQuickviewDetails,
  fetchPubQuickview,
  pushPublisherToSalesforce,
  fetchCompanyQuickview,
};
